import { Array as RunTypesArray, Literal, Record, String, Union } from "runtypes";
/**
 * DNS-DID verification status
 */
export const ValidDnsDidVerificationStatus = Record({
    status: Literal("VALID"),
    location: String,
    key: String,
});
export const ValidDnsDidVerificationStatusArray = RunTypesArray(ValidDnsDidVerificationStatus).withConstraint((elements) => elements.length > 0 || "Expect at least one valid element");
export const InvalidDnsDidVerificationStatus = Record({
    status: Literal("INVALID"),
    location: String,
    key: String,
});
export const DnsDidVerificationStatus = Union(ValidDnsDidVerificationStatus, InvalidDnsDidVerificationStatus);
export const DnsDidVerificationStatusArray = RunTypesArray(DnsDidVerificationStatus);
